export const REGEX_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const REGEX_NUMERIC = /^\d+$/;
export const REGEX_PHONE = /^[+]\d+\s?\d+$/;
export const B64_MAX_BYTES = (data: string, maxBytes: number) => {
    // Determine base64 padding which is not part of the data
    const padding = data.endsWith('==') ? 2 : data.endsWith('=') ? 1 : 0;
    // Approximate size in bytes: 4 characters encode 3 bytes
    const size = data.length * 0.75 - padding;

    return size <= maxBytes;
};
